import { useMemo } from 'react'

export const useWhen = <T, F>(condition: boolean, trulyHook: T, falsyHook: F) => {
  return useMemo(
    () => condition ? trulyHook : falsyHook,
    [condition, trulyHook, falsyHook]
  )
}
